
export type Language = 'es' | 'en' | 'pt' | 'fr' | 'it' | 'de';

export const LANGUAGE_NAMES: Record<Language, string> = {
  es: 'Español',
  en: 'English',
  pt: 'Português',
  fr: 'Français',
  it: 'Italiano',
  de: 'Deutsch',
};

export const LANGUAGES: Language[] = ['es', 'en', 'pt', 'fr', 'it', 'de'];

export const translations: Record<Language, Record<string, string>> = {
  es: {
    nav_home: 'Inicio', nav_expeditions: 'Elige tu ruta', nav_about: 'Nuestra Historia', nav_certifications: 'Certificaciones', nav_book: 'Reservar', nav_blog: 'Blog',
    home_seo_title: 'Fisura Expeditions | Tours de trekking y escalada en Patagonia',
    home_seo_desc: 'Operador turístico oficial en Villa Cerro Castillo y Aysén. Especialistas en tours de trekking a Laguna Cerro Castillo, Travesía Las Horquetas y escalada técnica en Patagonia.',
    hero_operator_badge: 'Operador turístico especializado en trekking y escalada en Patagonia',
    hero_tagline: 'La Cordillera del Castillo te espera', hero_cta: 'Ver expediciones',
    seo_season_title: 'La Temporada en Aysén',
    seo_season_text: 'Operamos de Octubre a Abril. El clima en Aysén es impredecible, pero es en estos meses cuando el granito se deja escalar y los ríos permiten el paso.',
    seo_village_title: 'Villa Cerro Castillo',
    seo_village_text: 'Ubicada a 95km de Coyhaique, la villa es el campo base de la aventura. Un pueblo de cultura gaucha donde el tiempo corre distinto.',
    featured_title: 'DESCUBRE EL GRANITO',
    featured_text: 'Nuestro compromiso se centra en la montaña y la autenticidad. Brindamos experiencias que transforman a través del respeto y la conexión profunda.',
    featured_cta: 'Explorar Catálogo',
    about_ecosystem: 'Nuestra Historia y Ecosistema',
    about_title: 'MARAVILLADOS POR LAS MONTAÑAS',
    about_text: 'Fisura Expeditions surge por la motivación de compartir la belleza y energía que transmite la naturaleza de la Patagonia.\nEl deporte y la aventura nos han llevado a conocer muchos lugares, pero hay algo en la Patagonia que nos hace volver siempre, y sentirnos parte de ella.\n\nTe invitamos a explorarla con nosotros. Nos especializamos en otorgar experiencias deportivas en la naturaleza. Nuestros guías locales con acreditación ANGM, UIMLA y WFR te garantizan seguridad y excelencia técnica en cada expedición.\n\nElige la dificultad y el terreno. Desde un paseo por el lago hasta una expedición en alta montaña.\n\nRoca, hielo, agua y nieve están esperando por ti. Sus colores, su fuerza y su energía te darán una experiencia inolvidable.',
    about_philosophy_title: 'Nuestra filosofía',
    about_philosophy_text: 'Respeto total y absoluto por la montaña. Impacto cero al medioambiente.',
    about_location_title: 'Ubicación Estratégica',
    about_location_text: 'Operamos desde Villa Cerro Castillo, el corazón técnico de Aysén. Sin intermediarios.',
    about_safety_title: 'Seguridad Activa',
    about_safety_text: 'Cada salida incluye comunicación satelital y protocolos de rescate actualizados anualmente.',
    trust_angm: 'Guía Certificado ANGM', trust_wfr: 'Soporte Vital WFR', trust_gps: 'Satelital InReach',
    trust_lang: 'Multilingüe', trust_groups: 'Grupos Íntimos', trust_ndr: 'Sin Rastro',
    exp_title: 'EXPEDICIONES', exp_subtitle: 'Seleccionadas por su pureza y exigencia.',
    cat_all: 'Todo', cat_trekking: 'Trekking', cat_climbing: 'Escalada', cat_water: 'Agua', cat_wellness: 'Wellness', cat_fishing: 'Pesca',
    difficulty: 'Dificultad', duration: 'Tiempo', distance: 'Distancia', from: 'Desde', consult: 'Consultar tarifa',
    diff_mid: 'Media-Alta', diff_high: 'Exigente', diff_low: 'Accesible',
    detail_back: 'Regresar', detail_includes: 'Nuestra Experiencia Incluye', detail_not_includes: 'Preparación Personal',
    itinerary: 'El Camino', day: 'Jornada',
    booking_title: 'Solicita tu cupo', booking_people: 'Exploradores', booking_date: 'Fecha de salida',
    booking_name: 'Nombre completo', booking_email: 'Tu correo', booking_phone: 'WhatsApp/Teléfono',
    booking_airport: '¿Buscas traslado al aeropuerto? (+USD$50)', booking_submit: 'Reservar',
    booking_sent: 'ENVIADO', booking_sent_text: 'Nos contactaremos en breve.', booking_close: 'CERRAR',
    terms_title: 'REGLAS DE MONTAÑA', footer_location: 'Villa Cerro Castillo, Aysén, Chile',
    footer_newsletter_title: 'BOLETÍN INFORMATIVO',
    footer_newsletter_desc: 'Recibe rutas de escalada y condiciones actualizadas de Aysén en tu bandeja.',
    footer_newsletter_placeholder: 'Tu correo electrónico',
    footer_newsletter_btn: 'SUSCRIBIRSE',
    footer_instagram_title: 'FEED DE INSTAGRAM',
    footer_instagram_follow: 'SÍGUENOS @FISURAEXPEDITIONS',
    footer_rescue_title: 'ASEGURA TU EXPEDICIÓN',
    footer_social: 'REDES SOCIALES',
    footer_payment_methods: 'MEDIOS DE PAGO',
    price_total: 'Inversión Total', price_per_person: 'por explorador',
    price_includes_boxlunch: 'Incluye Box Lunch por persona',
    pricing_title: 'Cuadro de Inversión',
    pricing_pax: 'Exploradores',
    pricing_per_person: 'p/persona',
    nutrition_title: 'Nutrición en Terreno',
    nutrition_meal: 'Comida',
    nutrition_example: 'Ejemplo Día 1',
    nutrition_note: 'Nota del Guía',
    variants_title: 'Elige tu Escalada',
    booking_variant: 'Tipo de Escalada',
    services_title: 'Diseña tu itinerario',
    error_404_title: 'Ruta no encontrada',
    error_404_text: 'El sendero continúa por otro lado. Sigue explorando y encuentra la ruta correcta de la mano del Guardián del Castillo.',
    error_404_cta: 'Volver al inicio',
    success_title: '¡Solicitud recibida!',
    success_subtitle: 'Tu aventura comienza ahora.',
    success_text: 'Hemos recibido tus detalles. Un guía local revisará la disponibilidad y se contactará contigo en breve para coordinar los detalles técnicos.',
    success_cta: 'Ver más expediciones',
    whatsapp_chat: 'Hablemos por WhatsApp',
    newsletter_success: '¡Suscripción exitosa!',
    newsletter_error: 'Ocurrió un error. Inténtalo de nuevo.',
    blog_title: 'Blog: Consejos y Relatos de Montaña',
    blog_subtitle: 'Historias, guías técnicas y recomendaciones de montaña en Aysén.',
    blog_read_more: 'Leer artículo',
    blog_min_read: 'min de lectura',
    blog_empty: 'Pronto publicaremos nuevos artículos y guías de montaña. ¡Vuelve pronto!',
    blog_back: 'Volver al Blog',
    blog_share: 'Compartir artículo',
    blog_cta_title: '¿Inspirado para tu próxima aventura?',
    blog_cta_desc: 'Conoce nuestras expediciones guiadas con seguridad certificada y grupos reducidos en Aysén.',
    blog_cta_btn: 'Explorar Expediciones',
    sernatur_accredited: 'Acreditados',
    sernatur_guide: 'Sernatur',
    sernatur_official: 'Registro Oficial',
    sernatur_provider: 'Prestador de Servicios',
    sustainability_title: 'Turismo Sustentable',
    sustainability_subtitle: 'Buenas Prácticas',
    certifications_all: 'Ver certificaciones y reconocimientos',
    footer_explore: 'Rutas',
    map_badge: 'Ubicación y Cobertura',
    map_title: 'Nuestras Rutas en Aysén',
    map_desc: 'Explora los puntos estratégicos donde operamos desde la Región de Aysén hasta las Torres del Paine. Selecciona una categoría para filtrar.',
    map_directory: 'Directorio Completo',
    map_view_all: 'Ver todas',
    map_view_more: 'Ver más →',
    map_no_results: 'Sin resultados',
  },
  en: {
    nav_home: 'Home', nav_expeditions: 'Explore Routes', nav_about: 'Our Story', nav_certifications: 'Certifications', nav_book: 'Book Now', nav_blog: 'Blog',
    home_seo_title: 'Fisura Expeditions | Trekking & Climbing Tours in Patagonia',
    home_seo_desc: 'Official tour operator in Villa Cerro Castillo and Aysén. Specialists in trekking tours to Laguna Cerro Castillo, Las Horquetas traverse, and rock climbing in Patagonia.',
    hero_operator_badge: 'Specialized tour operator for trekking & climbing in Patagonia',
    hero_tagline: 'The Castillo Mountain Range awaits', hero_cta: 'Explore Routes',
    seo_season_title: 'Season in Aysén',
    seo_season_text: 'We operate from October to April. The weather in Aysén is unpredictable, but during these months the granite is climbable and the rivers allow passage.',
    seo_village_title: 'Villa Cerro Castillo',
    seo_village_text: "Located 95km from Coyhaique, the village is adventure's basecamp. A town of gaucho culture where time runs differently.",
    featured_title: 'DISCOVER THE GRANITE',
    featured_text: 'Our commitment is centered on the mountain and authenticity. We provide life-changing experiences through respect and deep connection.',
    featured_cta: 'Explore Catalog',
    about_ecosystem: 'Our Story and Ecosystem',
    about_title: 'MARVELED BY THE MOUNTAINS',
    about_text: 'Fisura Expeditions was born from the passion to share the raw beauty and energy that Patagonia’s nature conveys.\nSports and adventure have taken us to many places, but there is something in Patagonia that constantly calls us back and makes us feel part of it.\n\nWe invite you to explore it with us. We specialize in providing outdoor mountain experiences. Our local guides, certified by ANGM, UIMLA, and WFR, guarantee safety and technical excellence on every expedition.\n\nChoose your difficulty and terrain: from a scenic lake walk to a high-mountain expedition.\n\nRock, ice, water, and snow are waiting for you. Their colors, power, and vitality will give you an unforgettable experience.',
    about_philosophy_title: 'Our Philosophy',
    about_philosophy_text: 'Deep respect for the mountain and its fragile ecosystems.',
    about_location_title: 'Strategic Location',
    about_location_text: 'We operate from Villa Cerro Castillo, the technical heart of Aysén.',
    about_safety_title: 'Active Safety',
    about_safety_text: 'Every departure includes satellite communication and annually updated rescue protocols.',
    trust_angm: 'ANGM Certified Guide', trust_wfr: 'WFR Medical Support', trust_gps: 'InReach Satellite',
    trust_lang: 'Multilingual', trust_groups: 'Tiny Groups', trust_ndr: 'Leave No Trace',
    exp_title: 'EXPEDITIONS', exp_subtitle: 'Selected for their purity and challenge.',
    cat_all: 'All', cat_trekking: 'Trekking', cat_climbing: 'Climbing', cat_water: 'Water', cat_wellness: 'Wellness', cat_fishing: 'Fishing',
    difficulty: 'Technicality', duration: 'Duration', distance: 'Distance', from: 'Starting at', consult: 'Inquire for rates',
    diff_mid: 'Moderate-High', diff_high: 'Demanding', diff_low: 'Accessible',
    detail_back: 'Back to base', detail_includes: 'Our Experience Includes', detail_not_includes: 'Personal Preparation',
    itinerary: 'The Journey', day: 'Day',
    booking_title: 'Request your spot', booking_people: 'Hikers', booking_date: 'Departure date',
    booking_name: 'Full Name', booking_email: 'Email address', booking_phone: 'Phone number',
    booking_airport: 'Need airport shuttle? (+USD$50)', booking_submit: 'Book Now',
    booking_sent: 'SENT', booking_sent_text: 'We will contact you soon.', booking_close: 'CLOSE',
    terms_title: 'MOUNTAIN RULES', footer_location: 'Villa Cerro Castillo, Aysén, Chile',
    footer_newsletter_title: 'NEWSLETTER',
    footer_newsletter_desc: 'Get climbing routes and updated Aysén conditions in your inbox.',
    footer_newsletter_placeholder: 'Your email address',
    footer_newsletter_btn: 'SUBSCRIBE',
    footer_instagram_title: 'INSTAGRAM FEED',
    footer_instagram_follow: 'FOLLOW US @FISURAEXPEDITIONS',
    footer_rescue_title: 'INSURE YOUR EXPEDITION',
    footer_social: 'SOCIAL MEDIA',
    footer_payment_methods: 'PAYMENT METHODS',
    price_total: 'Total Investment', price_per_person: 'per hiker',
    price_includes_boxlunch: 'Includes Box Lunch per person',
    pricing_title: 'Pricing Tiers',
    pricing_pax: 'Explorers',
    pricing_per_person: 'p/person',
    nutrition_title: 'Field Nutrition',
    nutrition_meal: 'Meal',
    nutrition_example: 'Example Day 1',
    nutrition_note: 'Guide Notes',
    variants_title: 'Choose your Climbing Style',
    booking_variant: 'Climbing Type',
    services_title: 'Design your itinerary',
    error_404_title: 'Route Not Found',
    error_404_text: "The trail continues elsewhere. Keep exploring and find the right path guided by the Guardian of the Castle.",
    error_404_cta: 'Back to Home',
    success_title: 'Request Received!',
    success_subtitle: 'Your adventure starts now.',
    success_text: 'We have received your details. A local guide will check availability and contact you shortly to coordinate the technical details.',
    success_cta: 'Explore more routes',
    whatsapp_chat: "Let's chat on WhatsApp",
    newsletter_success: 'Subscription successful!',
    newsletter_error: 'An error occurred. Please try again.',
    blog_title: 'Blog: Mountain Tips & Stories',
    blog_subtitle: 'Stories, technical guides, and mountain tips in Aysén.',
    blog_read_more: 'Read article',
    blog_min_read: 'min read',
    blog_empty: 'We will be publishing new stories and mountain guides soon. Check back shortly!',
    blog_back: 'Back to Blog',
    blog_share: 'Share article',
    blog_cta_title: 'Inspired for your next expedition?',
    blog_cta_desc: 'Explore our guided expeditions with certified safety and intimate small groups in Aysén.',
    blog_cta_btn: 'Explore Expeditions',
    sernatur_accredited: 'Certified',
    sernatur_guide: 'Sernatur Guide',
    sernatur_official: 'Official Registry',
    sernatur_provider: 'Tour Operator',
    sustainability_title: 'Sustainable Tourism',
    sustainability_subtitle: 'Good Practices',
    certifications_all: 'View official certifications & badges',
    footer_explore: 'Explore',
    map_badge: 'Location & Coverage',
    map_title: 'Our Routes in Aysén',
    map_desc: 'Explore our strategic operating locations across the Aysén Region and Patagonia. Select a category to filter.',
    map_directory: 'Full Catalog',
    map_view_all: 'View all',
    map_view_more: 'View more →',
    map_no_results: 'No results found',
  },
  pt: {
    nav_home: 'Início', nav_expeditions: 'Explorar Rotas', nav_about: 'Nossa História', nav_certifications: 'Certificações', nav_book: 'Reservar', nav_blog: 'Blog',
    home_seo_title: 'Fisura Expeditions | Passeios de Trekking e Escalada na Patagônia',
    home_seo_desc: 'Operador turístico oficial em Villa Cerro Castillo e Aysén. Especialistas em passeios de trekking na Laguna Cerro Castillo, Travessia Las Horquetas e escalada na Patagônia.',
    hero_operator_badge: 'Operador turístico especializado em trekking e escalada na Patagônia',
    hero_tagline: 'O guardião do Castelo espera por você', hero_cta: 'Ver expedições',
    seo_season_title: 'A Temporada em Aysén',
    seo_season_text: 'Operamos de outubro a abril. O clima em Aysén é imprevisível, mas é nesses meses que o granito permite a escalada e os rios permitem a passagem.',
    seo_village_title: 'Villa Cerro Castillo',
    seo_village_text: 'Localizada a 95km de Coyhaique, a vila é o acampamento base da aventura. Uma cidade de cultura gaúcha onde o tempo corre diferente.',
    featured_title: 'DESCUBRA O GRANITO',
    featured_text: 'Nosso compromisso é com a montanha e a autenticidade. Oferecemos experiências que transformam através do respeito e da conexão profunda.',
    featured_cta: 'Explorar Catálogo',
    about_ecosystem: 'Nossa História e Ecossistema',
    about_title: 'MARAVILHADOS PELAS MONTANHAS',
    about_text: 'A Fisura Expeditions surge da motivação de compartilhar a beleza e a energia que a natureza da Patagônia transmite.\nO esporte e a aventura nos levaram a conhecer muitos lugares, mas há algo na Patagônia que sempre nos faz voltar e nos sentir parte dela.\n\nConvidamos você a explorá-la conosco. Somos especialistas em proporcionar experiências esportivas na natureza. Nossos guias locais com certificação ANGM, UIMLA e WFR garantem segurança e excelência técnica em cada expedição.\n\nEscolha a dificuldade e o terreno: desde um passeio pelo lago até uma expedição em alta montanha.\n\nRocha, gelo, água e neve estão esperando por você. Suas cores, sua força e sua energia proporcionarão uma experiência inesquecível.',
    about_philosophy_title: 'Nossa Filosofia',
    about_philosophy_text: 'Respeito total pela montanha e seus ecossistemas.',
    about_location_title: 'Localização Estratégica',
    about_location_text: 'Operamos a partir de Villa Cerro Castillo, o coração técnico de Aysén.',
    about_safety_title: 'Segurança Ativa',
    about_safety_text: 'Cada saída inclui comunicação via satélite e protocolos de resgate atualizados anualmente.',
    trust_angm: 'Guia Certificado ANGM', trust_wfr: 'Suporte Médico WFR', trust_gps: 'Satélite InReach',
    trust_lang: 'Multilíngue', trust_groups: 'Grupos Íntimos', trust_ndr: 'Sem Rastro',
    exp_title: 'EXPEDIÇÕES', exp_subtitle: 'Selecionadas por sua pureza e exigência.',
    cat_all: 'Tudo', cat_trekking: 'Trekking', cat_climbing: 'Escalada', cat_water: 'Água', cat_wellness: 'Wellness', cat_fishing: 'Pesca',
    difficulty: 'Dificuldade', duration: 'Duração', distance: 'Distância', from: 'A partir de', consult: 'Consultar tarifa',
    diff_mid: 'Média-Alta', diff_high: 'Exigente', diff_low: 'Acessível',
    detail_back: 'Voltar', detail_includes: 'Nossa Experiência Inclui', detail_not_includes: 'Preparação Pessoal',
    itinerary: 'O Caminho', day: 'Dia',
    booking_title: 'Solicite sua vaga', booking_people: 'Exploradores', booking_date: 'Data de saída',
    booking_name: 'Nome completo', booking_email: 'Seu e-mail', booking_phone: 'WhatsApp/Telefone',
    booking_airport: 'Precisa de traslado para o aeroporto? (+USD$50)', booking_submit: 'Reservar',
    booking_sent: 'ENVIADO', booking_sent_text: 'Entraremos em contato em breve.', booking_close: 'FECHAR',
    terms_title: 'REGRAS DA MONTANHA', footer_location: 'Villa Cerro Castillo, Aysén, Chile',
    footer_newsletter_title: 'BOLETIM INFORMATIVO',
    footer_newsletter_desc: 'Receba rotas de escalada e condições de Aysén.',
    footer_newsletter_placeholder: 'Seu endereço de e-mail',
    footer_newsletter_btn: 'INSCREVER',
    footer_instagram_title: 'FEED DO INSTAGRAM',
    footer_instagram_follow: 'SIGA-NOS @FISURAEXPEDITIONS',
    footer_rescue_title: 'ASSEGURE SUA EXPEDIÇÃO',
    footer_social: 'REDES SOCIAIS',
    footer_payment_methods: 'MEIOS DE PAGAMENTO',
    price_total: 'Investimento Total', price_per_person: 'por explorador',
    price_includes_boxlunch: 'Inclui Box Lunch por pessoa',
    pricing_title: 'Quadro de Investimento',
    pricing_pax: 'Exploradores',
    pricing_per_person: 'p/pessoa',
    nutrition_title: 'Nutrição em Campo',
    nutrition_meal: 'Refeição',
    nutrition_example: 'Exemplo Dia 1',
    nutrition_note: 'Nota do Guia',
    variants_title: 'Escolha sua Escalada',
    booking_variant: 'Tipo de Escalada',
    services_title: 'Desenhe seu itinerário',
    error_404_title: 'Rota não encontrada',
    error_404_text: 'A trilha continua por outro caminho. Continue explorando e encontre a rota certa guiado pelo Guardião do Castelo.',
    error_404_cta: 'Voltar ao início',
    success_title: 'Solicitação recebida!',
    success_subtitle: 'Sua aventura começa agora.',
    success_text: 'Recebemos suas informações. Um guia local verificará a disponibilidade e entrará em contato em breve para coordenar os detalhes técnicos.',
    success_cta: 'Ver mais expedições',
    whatsapp_chat: 'Fale conosco pelo WhatsApp',
    newsletter_success: 'Inscrição realizada com sucesso!',
    newsletter_error: 'Ocorreu um erro. Tente novamente.',
    blog_title: 'Blog: Dicas e Histórias da Montanha',
    blog_subtitle: 'Histórias, guias técnicos e dicas de montanha em Aysén.',
    blog_read_more: 'Ler artigo',
    blog_min_read: 'min de leitura',
    blog_empty: 'Em breve publicaremos novas histórias e guias de montanha. Volte em breve!',
    blog_back: 'Voltar ao Blog',
    blog_share: 'Compartilhar artigo',
    blog_cta_title: 'Inspirado para sua próxima expedição?',
    blog_cta_desc: 'Conheça nossas expedições guiadas com segurança certificada e grupos reduzidos em Aysén.',
    blog_cta_btn: 'Ver Expedições',
    sernatur_accredited: 'Acreditados',
    sernatur_guide: 'Sernatur',
    sernatur_official: 'Registro Oficial',
    sernatur_provider: 'Prestador de Serviços',
    sustainability_title: 'Turismo Sustentável',
    sustainability_subtitle: 'Boas Práticas',
    certifications_all: 'Ver certificações e reconhecimentos',
    footer_explore: 'Rotas',
    map_badge: 'Localização e Cobertura',
    map_title: 'Nossas Rotas em Aysén',
    map_desc: 'Explore nossos pontos estratégicos na Região de Aysén e Patagônia. Selecione uma categoria para filtrar.',
    map_directory: 'Catálogo Completo',
    map_view_all: 'Ver todas',
    map_view_more: 'Ver mais →',
    map_no_results: 'Nenhum resultado encontrado',
  },
  fr: {
    nav_home: 'Accueil', nav_expeditions: 'Explorer les Routes', nav_about: 'Notre Histoire', nav_certifications: 'Certifications', nav_book: 'Réserver', nav_blog: 'Blog',
    home_seo_title: 'Fisura Expeditions | Tours de Trekking et Escalade en Patagonie',
    home_seo_desc: 'Opérateur touristique officiel à Villa Cerro Castillo et Aysén. Spécialistes des tours de trekking à Laguna Cerro Castillo, Traversée Las Horquetas et escalade en Patagonie.',
    hero_operator_badge: 'Opérateur touristique spécialisé en trekking et escalade en Patagonie',
    hero_tagline: 'Le gardien du Château vous attend', hero_cta: 'Voir les expéditions',
    seo_season_title: 'La Saison en Aysén',
    seo_season_text: "Nous opérons d'octobre à avril. Le temps en Aysén est imprévisible, mais c'est durant ces mois que le granite se laisse escalader et les rivières permettent le passage.",
    seo_village_title: 'Villa Cerro Castillo',
    seo_village_text: "Située à 95km de Coyhaique, la villa est le camp de base de l'aventure. Un village de culture gaucho où le temps s'écoule différemment.",
    featured_title: 'DÉCOUVREZ LE GRANIT',
    featured_text: "Notre engagement est tourné vers la montagne et l'authenticité. Nous offrons des expériences transformatrices basées sur le respect et une connexion profonde.",
    featured_cta: 'Explorer le Catalogue',
    about_ecosystem: 'Notre Histoire et Écosystème',
    about_title: 'ÉMERVEILLÉS PAR LES MONTAGNES',
    about_text: 'Fisura Expeditions est née de la passion de partager la beauté et l\'énergie que transmet la nature de la Patagonie.\nLe sport et l\'aventure nous ont amenés à découvrir de nombreux endroits, mais il y a quelque chose en Patagonie qui nous pousse toujours à revenir et à nous sentir chez nous.\n\nNous vous invitons à l\'explorer avec nous. Nous sommes spécialisés dans les expériences sportives en pleine nature. Nos guides locaux certifiés ANGM, UIMLA et WFR garantissent votre sécurité et une excellence technique lors de chaque expédition.\n\nChoisissez la difficulté et le terrain : d\'une balade paisible au bord du lac jusqu\'à une expédition en haute montagne.\n\nRoche, glace, eau et neige vous attendent. Leurs couleurs, leur force et leur vitalité vous feront vivre une expérience inoubliable.',
    about_philosophy_title: 'Notre Philosophie',
    about_philosophy_text: 'Respect total de la montagne et de ses écosystèmes.',
    about_location_title: 'Emplacement Stratégique',
    about_location_text: 'Nous opérons depuis Villa Cerro Castillo, le cœur technique d\'Aysén.',
    about_safety_title: 'Sécurité Active',
    about_safety_text: 'Chaque départ comprend une communication par satellite et des protocoles de secours mis à jour annuellement.',
    trust_angm: 'Guide Certifié ANGM', trust_wfr: 'Support Médical WFR', trust_gps: 'Satellite InReach',
    trust_lang: 'Multilingue', trust_groups: 'Petits Groupes', trust_ndr: 'Sans Trace',
    exp_title: 'EXPÉDITIONS', exp_subtitle: 'Sélectionnées pour leur pureté et leur exigence.',
    cat_all: 'Tout', cat_trekking: 'Trekking', cat_climbing: 'Escalade', cat_water: 'Eau', cat_wellness: 'Wellness', cat_fishing: 'Pêche',
    difficulty: 'Difficulté', duration: 'Durée', distance: 'Distance', from: 'À partir de', consult: 'Demander le tarif',
    diff_mid: 'Moyen-Élevé', diff_high: 'Exigeant', diff_low: 'Accessible',
    detail_back: 'Retour', detail_includes: 'Notre Expérience Inclut', detail_not_includes: 'Préparation Personnelle',
    itinerary: 'Le Parcours', day: 'Jour',
    booking_title: 'Demandez votre place', booking_people: 'Explorateurs', booking_date: 'Date de départ',
    booking_name: 'Nom complet', booking_email: 'Votre e-mail', booking_phone: 'WhatsApp/Téléphone',
    booking_airport: 'Navette aéroport? (+USD$50)', booking_submit: 'Réserver',
    booking_sent: 'ENVOYÉ', booking_sent_text: 'Nous vous contacterons bientôt.', booking_close: 'FERMER',
    terms_title: 'RÈGLES DE MONTAGNE', footer_location: 'Villa Cerro Castillo, Aysén, Chili',
    footer_newsletter_title: 'NEWSLETTER',
    footer_newsletter_desc: 'Recevez les voies d\'escalade et les conditions d\'Aysén.',
    footer_newsletter_placeholder: 'Votre adresse e-mail',
    footer_newsletter_btn: 'S\'ABONNER',
    footer_instagram_title: 'FLUX INSTAGRAM',
    footer_instagram_follow: 'SUIVEZ-NOUS @FISURAEXPEDITIONS',
    footer_rescue_title: 'ASSUREZ VOTRE EXPÉDITION',
    footer_social: 'RÉSEAUX SOCIAUX',
    footer_payment_methods: 'MOYENS DE PAIEMENT',
    price_total: 'Investissement Total', price_per_person: 'par explorateur',
    price_includes_boxlunch: 'Comprend un panier-repas par personne',
    pricing_title: 'Tableau des Tarifs',
    pricing_pax: 'Explorateurs',
    pricing_per_person: 'p/personne',
    nutrition_title: 'Nutrition sur le Terrain',
    nutrition_meal: 'Repas',
    nutrition_example: 'Exemple Jour 1',
    nutrition_note: 'Note du Guide',
    variants_title: 'Choisissez votre Escalade',
    booking_variant: 'Type d\'Escalade',
    services_title: 'Concevez votre itinéraire',
    error_404_title: 'Route introuvable',
    error_404_text: 'Le sentier se poursuit ailleurs. Continuez d\'explorer et trouvez le bon chemin guidé par le Gardien du Château.',
    error_404_cta: 'Retour à l\'accueil',
    success_title: 'Demande reçue !',
    success_subtitle: 'Votre aventure commence maintenant.',
    success_text: 'Nous avons bien reçu vos coordonnées. Un guide local vérifiera la disponibilité et vous contactera sous peu pour coordonner les détails techniques.',
    success_cta: 'Voir d\'autres expéditions',
    whatsapp_chat: 'Parlons sur WhatsApp',
    newsletter_success: 'Inscription réussie !',
    newsletter_error: 'Une erreur est survenue. Veuillez réessayer.',
    blog_title: 'Blog: Conseils et Récits de Montagne',
    blog_subtitle: 'Histoires, guides techniques et conseils de montagne en Aysén.',
    blog_read_more: 'Lire l\'article',
    blog_min_read: 'min de lecture',
    blog_empty: 'Nous publierons bientôt de nouveaux articles et guides de montagne.',
    blog_back: 'Retour au Blog',
    blog_share: 'Partager l\'article',
    blog_cta_title: 'Inspiré pour votre prochaine aventure ?',
    blog_cta_desc: 'Découvrez nos expéditions guidées en petits groupes avec sécurité certifiée.',
    blog_cta_btn: 'Explorer les Expéditions',
    sernatur_accredited: 'Accrédités',
    sernatur_guide: 'Sernatur',
    sernatur_official: 'Registre Officiel',
    sernatur_provider: 'Opérateur Touristique',
    sustainability_title: 'Tourisme Durable',
    sustainability_subtitle: 'Bonnes Pratiques',
    certifications_all: 'Voir certifications et reconnaissances',
    footer_explore: 'Routes',
    map_badge: 'Localisation et Couverture',
    map_title: 'Nos Routes en Aysén',
    map_desc: 'Explorez nos bases opérationnelles dans la région d\'Aysén. Sélectionnez une catégorie pour filtrer.',
    map_directory: 'Catalogue Complet',
    map_view_all: 'Voir tout',
    map_view_more: 'Voir plus →',
    map_no_results: 'Aucun résultat trouvé',
  },
  it: {
    nav_home: 'Home', nav_expeditions: 'Esplora i Percorsi', nav_about: 'La Nostra Storia', nav_certifications: 'Certificazioni', nav_book: 'Prenota', nav_blog: 'Blog',
    home_seo_title: 'Fisura Expeditions | Tour di Trekking e Arrampicata in Patagonia',
    home_seo_desc: 'Operatore turistico ufficiale a Villa Cerro Castillo e Aysén. Specialisti in tour di trekking alla Laguna Cerro Castillo, Traversata Las Horquetas e arrampicata in Patagonia.',
    hero_operator_badge: 'Operatore turistico specializzato in trekking e arrampicata in Patagonia',
    hero_tagline: 'Il guardiano del Castello ti aspetta', hero_cta: 'Vedi le spedizioni',
    seo_season_title: 'La Stagione in Aysén',
    seo_season_text: "Operiamo da ottobre ad aprile. Il tempo in Aysén è imprevedibile, ma è in questi mesi che il granito si lascia scalare e i fiumi permettono il passaggio.",
    seo_village_title: 'Villa Cerro Castillo',
    seo_village_text: "Situata a 95km da Coyhaique, la villa è il campo base dell'avventura. Un villaggio di cultura gaucha dove il tempo scorre diversamente.",
    featured_title: 'SCOPRI IL GRANITO',
    featured_text: "Il nostro impegno è rivolto alla montagna e all'autenticità. Offriamo esperienze che trasformano attraverso il rispetto e una connessione profonda.",
    featured_cta: 'Esplora il Catalogo',
    about_ecosystem: 'La Nostra Storia ed Ecosistema',
    about_title: 'MERAVIGLIATI DALLE MONTAGNE',
    about_text: 'Fisura Expeditions nasce dalla motivazione di condividere la bellezza e l’energia che la natura della Patagonia trasmette.\nLo sport e l’avventura ci hanno portato a scoprire molti luoghi, ma c’è qualcosa nella Patagonia che ci fa sempre tornare e sentirci parte di essa.\n\nTi invitiamo a esplorarla con noi. Siamo specializzati in esperienze sportive all’aria aperta. Le nostre guide locali con accreditamento ANGM, UIMLA e WFR garantiscono sicurezza ed eccellenza tecnica in ogni spedizione.\n\nScegli la difficoltà e il terreno: da una tranquilla passeggiata lungo il lago a una spedizione in alta montagna.\n\nRoccia, ghiaccio, acqua e neve ti stanno aspettando. I loro colori, la loro forza e la loro vitalità ti regaleranno un’esperienza indimenticabile.',
    about_philosophy_title: 'La Nostra Filosofia',
    about_philosophy_text: 'Rispetto totale per la montagna e i suoi ecosistemi.',
    about_location_title: 'Posizione Strategica',
    about_location_text: 'Operiamo da Villa Cerro Castillo, il cuore tecnico di Aysén.',
    about_safety_title: 'Sicurezza Attiva',
    about_safety_text: 'Ogni partenza include comunicazione satellitare e protocolli di soccorso aggiornati annualmente.',
    trust_angm: 'Guida Certificata ANGM', trust_wfr: 'Supporto Medico WFR', trust_gps: 'Satellite InReach',
    trust_lang: 'Multilingue', trust_groups: 'Gruppi Intimi', trust_ndr: 'Senza Traccia',
    exp_title: 'SPEDIZIONI', exp_subtitle: 'Selezionate per la loro purezza ed esigenza.',
    cat_all: 'Tutto', cat_trekking: 'Trekking', cat_climbing: 'Arrampicata', cat_water: 'Acqua', cat_wellness: 'Wellness', cat_fishing: 'Pesca',
    difficulty: 'Difficoltà', duration: 'Durata', distance: 'Distanza', from: 'A partire da', consult: 'Richiedere tariffe',
    diff_mid: 'Medio-Alta', diff_high: 'Impegnativa', diff_low: 'Accessibile',
    detail_back: 'Indietro', detail_includes: 'La Nostra Esperienza Include', detail_not_includes: 'Preparazione Personale',
    itinerary: 'Il Percorso', day: 'Giorno',
    booking_title: 'Richiedi il tuo posto', booking_people: 'Esploratori', booking_date: 'Data di partenza',
    booking_name: 'Nome completo', booking_email: 'La tua email', booking_phone: 'WhatsApp/Telefono',
    booking_airport: 'Navetta aeroporto? (+USD$50)', booking_submit: 'Prenota',
    booking_sent: 'INVIATO', booking_sent_text: 'Ti contatteremo presto.', booking_close: 'CHIUDI',
    terms_title: 'REGOLE DELLA MONTAGNA', footer_location: 'Villa Cerro Castillo, Aysén, Cile',
    footer_newsletter_title: 'NEWSLETTER',
    footer_newsletter_desc: 'Ricevi vie d\'arrampicata e condizioni di Aysén.',
    footer_newsletter_placeholder: 'Il tuo indirizzo e-mail',
    footer_newsletter_btn: 'ISCRIVITI',
    footer_instagram_title: 'FEED INSTAGRAM',
    footer_instagram_follow: 'SEGUICI @FISURAEXPEDITIONS',
    footer_rescue_title: 'ASSICURA LA TUA SPEDIZIONE',
    footer_social: 'SOCIAL MEDIA',
    footer_payment_methods: 'METODI DI PAGAMENTO',
    price_total: 'Investimento Totale', price_per_person: 'per esploratore',
    price_includes_boxlunch: 'Include Box Lunch per persona',
    pricing_title: 'Tabella di Investimento',
    pricing_pax: 'Esploratori',
    pricing_per_person: 'p/persona',
    nutrition_title: 'Nutrizione sul Campo',
    nutrition_meal: 'Pasto',
    nutrition_example: 'Esempio Giorno 1',
    nutrition_note: 'Nota della Guida',
    variants_title: 'Scegli la tua Scalata',
    booking_variant: 'Tipo di Scalata',
    services_title: 'Disegna il tuo itinerario',
    error_404_title: 'Percorso non trovato',
    error_404_text: 'Il sentiero continua altrove. Continua a esplorare e trova il percorso giusto guidato dal Guardiano del Castello.',
    error_404_cta: 'Torna alla home',
    success_title: 'Richiesta ricevuta!',
    success_subtitle: 'La tua avventura inizia ora.',
    success_text: 'Abbiamo ricevuto i tuoi dettagli. Una guida locale verificherà la disponibilità e ti contatterà a breve per coordinare i dettagli tecnici.',
    success_cta: 'Vedi altre spedizioni',
    whatsapp_chat: 'Parliamo su WhatsApp',
    newsletter_success: 'Iscrizione completata con successo!',
    newsletter_error: 'Si è verificato un errore. Riprova.',
    blog_title: 'Blog: Consigli e Racconti di Montagna',
    blog_subtitle: 'Storie, guide tecniche e consigli per la montagna in Aysén.',
    blog_read_more: 'Leggi l\'articolo',
    blog_min_read: 'min di lettura',
    blog_empty: 'Presto pubblicheremo nuovi articoli e guide.',
    blog_back: 'Torna al Blog',
    blog_share: 'Condividi articolo',
    blog_cta_title: 'Ispirato per la tua prossima avventura?',
    blog_cta_desc: 'Scopri le nostre spedizioni guidate con guide certificate in Aysén.',
    blog_cta_btn: 'Esplora le Spedizioni',
    sernatur_accredited: 'Accreditati',
    sernatur_guide: 'Sernatur',
    sernatur_official: 'Registro Ufficiale',
    sernatur_provider: 'Fornitore di Servizi',
    sustainability_title: 'Turismo Sostenibile',
    sustainability_subtitle: 'Buone Pratiche',
    certifications_all: 'Visualizza certificazioni e riconoscimenti',
    footer_explore: 'Percorsi',
    map_badge: 'Posizione e Copertura',
    map_title: 'I Nostri Percorsi in Aysén',
    map_desc: 'Esplora le nostre basi operative nella regione di Aysén. Seleziona una categoria per filtrare.',
    map_directory: 'Catalogo Completo',
    map_view_all: 'Visualizza tutte',
    map_view_more: 'Visualizza altro →',
    map_no_results: 'Nessun risultato',
  },
  de: {
    nav_home: 'Startseite', nav_expeditions: 'Routen erkunden', nav_about: 'Unsere Geschichte', nav_certifications: 'Zertifizierungen', nav_book: 'Buchen', nav_blog: 'Blog',
    home_seo_title: 'Fisura Expeditions | Trekking- und Klettertouren in Patagonien',
    home_seo_desc: 'Offizieller Reiseveranstalter in Villa Cerro Castillo und Aysén. Spezialisten für Trekkingtouren zur Laguna Cerro Castillo, Horquetas-Traverse und Klettern in Patagonien.',
    hero_operator_badge: 'Spezialisierter Reiseveranstalter für Trekking & Klettern in Patagonien',
    hero_tagline: 'Der Wächter des Castillo erwartet dich', hero_cta: 'Expeditionen ansehen',
    seo_season_title: 'Die Saison in Aysén',
    seo_season_text: 'Wir operieren von Oktober bis April. Das Wetter in Aysén ist unberechenbar, aber in diesen Monaten ist der Granit begehbar und die Flüsse ermöglichen die Durchfahrt.',
    seo_village_title: 'Villa Cerro Castillo',
    seo_village_text: 'Das Dorf liegt 95 km von Coyhaique entfernt und ist das Basislager des Abenteuers. Ein Ort der Gaucho-Kultur, wo die Zeit anders läuft.',
    featured_title: 'ENTDECKE DEN GRANIT',
    featured_text: 'Unser Engagement gilt dem Berg und der Authentizität. Wir bieten transformierende Erlebnisse durch Respekt und tiefe Verbindung.',
    featured_cta: 'Katalog erkunden',
    about_ecosystem: 'Unsere Geschichte und Ökosystem',
    about_title: 'FASZINIERT VON DEN BERGEN',
    about_text: 'Fisura Expeditions entstand aus der Motivation, die Schönheit und Energie der Natur Patagoniens zu teilen.\nSport und Abenteuer haben uns an viele Orte geführt, aber es gibt etwas in Patagonien, das uns immer wieder zurückkehren lässt und uns als Teil davon fühlen lässt.\n\nWir laden dich ein, es mit uns zu erkunden. Wir sind auf Outdoor-Sporterlebnisse in der Natur spezialisiert. Unsere lokalen Guides mit ANGM-, UIMLA- und WFR-Zertifizierung garantieren Sicherheit und technische Exzellenz bei jeder Expedition.\n\nWähle Schwierigkeit und Gelände: vom ruhigen Spaziergang am See bis zur Hochgebirgsexpedition.\n\nFels, Eis, Wasser und Schnee warten auf dich. Ihre Farben, ihre Kraft und ihre Energie werden dir ein unvergessliches Erlebnis bescheren.',
    about_philosophy_title: 'Unsere Philosophie',
    about_philosophy_text: 'Tiefster Respekt für die Berge und ihre Ökosysteme.',
    about_location_title: 'Strategischer Standort',
    about_location_text: 'Wir operieren von Villa Cerro Castillo, dem technischen Herz von Aysén.',
    about_safety_title: 'Aktive Sicherheit',
    about_safety_text: 'Jede Abfahrt umfasst Satellitenkommunikation und jährlich aktualisierte Rettungsprotokolle.',
    trust_angm: 'ANGM-Zertifizierter Führer', trust_wfr: 'WFR-Medizinsupport', trust_gps: 'InReach-Satellit',
    trust_lang: 'Mehrsprachig', trust_groups: 'Kleine Gruppen', trust_ndr: 'Hinterlasse keine Spuren',
    exp_title: 'EXPEDITIONEN', exp_subtitle: 'Ausgewählt für ihre Reinheit und Anspruch.',
    cat_all: 'Alle', cat_trekking: 'Trekking', cat_climbing: 'Klettern', cat_water: 'Wasser', cat_wellness: 'Wellness', cat_fishing: 'Angeln',
    difficulty: 'Schwierigkeit', duration: 'Dauer', distance: 'Entfernung', from: 'Ab', consult: 'Preis anfragen',
    diff_mid: 'Mittel-Hoch', diff_high: 'Anspruchsvoll', diff_low: 'Zugänglich',
    detail_back: 'Zurück', detail_includes: 'Unser Erlebnis Beinhaltet', detail_not_includes: 'Persönliche Vorbereitung',
    itinerary: 'Die Route', day: 'Tag',
    booking_title: 'Platz anfragen', booking_people: 'Entdecker', booking_date: 'Abreisedatum',
    booking_name: 'Vollständiger Name', booking_email: 'Ihre E-Mail', booking_phone: 'WhatsApp/Telefon',
    booking_airport: 'Flughafentransfer? (+USD$50)', booking_submit: 'Buchen',
    booking_sent: 'GESENDET', booking_sent_text: 'Wir melden uns bald bei Ihnen.', booking_close: 'SCHLIESSEN',
    terms_title: 'BERGREGELN', footer_location: 'Villa Cerro Castillo, Aysén, Chile',
    footer_newsletter_title: 'NEWSLETTER',
    footer_newsletter_desc: 'Erhalte Kletterrouten und aktuelle Bedingungen.',
    footer_newsletter_placeholder: 'Deine E-Mail-Adresse',
    footer_newsletter_btn: 'ABONNIEREN',
    footer_instagram_title: 'INSTAGRAM FEED',
    footer_instagram_follow: 'FOLGE UNS @FISURAEXPEDITIONS',
    footer_rescue_title: 'SICHERE DEINE EXPEDITION AB',
    footer_social: 'SOZIALE MEDIEN',
    footer_payment_methods: 'ZAHLUNGSMETHODEN',
    price_total: 'Gesamtinvestition', price_per_person: 'pro Entdecker',
    price_includes_boxlunch: 'Inklusive Box-Lunch pro Person',
    pricing_title: 'Investitionsübersicht',
    pricing_pax: 'Entdecker',
    pricing_per_person: 'p/Person',
    nutrition_title: 'Verpflegung im Gelände',
    nutrition_meal: 'Mahlzeit',
    nutrition_example: 'Beispiel Tag 1',
    nutrition_note: 'Guide-Notiz',
    variants_title: 'Wähle deinen Kletterstil',
    booking_variant: 'Klettertyp',
    services_title: 'Gestalte deine Route',
    error_404_title: 'Route nicht gefunden',
    error_404_text: 'Der Weg führt woanders weiter. Erkunde weiter und finde den richtigen Pfad mit dem Wächter des Castillo.',
    error_404_cta: 'Zurück zur Startseite',
    success_title: 'Anfrage erhalten!',
    success_subtitle: 'Dein Abenteuer beginnt jetzt.',
    success_text: 'Wir haben deine Angaben erhalten. Ein lokaler Guide prüft die Verfügbarkeit und meldet sich in Kürze zur Abstimmung der technischen Details.',
    success_cta: 'Weitere Expeditionen ansehen',
    whatsapp_chat: 'Lass uns über WhatsApp chatten',
    newsletter_success: 'Abonnement erfolgreich!',
    newsletter_error: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
    blog_title: 'Blog: Bergtipps & Berichte',
    blog_subtitle: 'Geschichten, technische Führer und Bergtipps in Aysén.',
    blog_read_more: 'Artikel lesen',
    blog_min_read: 'Min. Lesezeit',
    blog_empty: 'Bald veröffentlichen wir neue Artikel und Bergführer.',
    blog_back: 'Zurück zum Blog',
    blog_share: 'Artikel teilen',
    blog_cta_title: 'Inspiriert für dein nächstes Abenteuer?',
    blog_cta_desc: 'Entdecke unsere geführten Expeditionen mit zertifizierter Sicherheit.',
    blog_cta_btn: 'Expeditionen entdecken',
    sernatur_accredited: 'Zertifiziert',
    sernatur_guide: 'Sernatur',
    sernatur_official: 'Offizielles Register',
    sernatur_provider: 'Dienstleister',
    sustainability_title: 'Nachhaltiger Tourismus',
    sustainability_subtitle: 'Gute Praktiken',
    certifications_all: 'Zertifizierungen und Auszeichnungen ansehen',
    footer_explore: 'Routen',
    map_badge: 'Standort und Abdeckung',
    map_title: 'Unsere Routen in Aysén',
    map_desc: 'Erkunde unsere operativen Stützpunkte in der Region Aysén. Wähle eine Kategorie zum Filtern.',
    map_directory: 'Vollständiger Katalog',
    map_view_all: 'Alle ansehen',
    map_view_more: 'Mehr anzeigen →',
    map_no_results: 'Keine Ergebnisse gefunden',
  },
};

export const WELLNESS_SERVICES: Record<Language, { name: string; benefit: string }[]> = {
  es: [
    { name: "Yoga al aire libre", benefit: "Despierta tu energía vital y encuentra equilibrio en un entorno natural único." },
    { name: "Asado patagónico", benefit: "Saborea la tradición gaucha con un festín de sabores locales y fuego lento." },
    { name: "Tinajas calientes", benefit: "Relajación profunda y desconexión total bajo el cielo infinito de la Patagonia." },
    { name: "Meditación", benefit: "Calma tu mente y reduce el estrés con técnicas de relajación profunda." },
    { name: "Cabalgatas", benefit: "Conecta con el espíritu del bosque nativo recorriendo senderos ancestrales." },
    { name: "Masajes", benefit: "Libera tensiones físicas y restaura tu cuerpo tras la aventura." }
  ],
  en: [
    { name: "Outdoor Yoga", benefit: "Awaken your vital energy and find balance in a unique natural setting." },
    { name: "Patagonian BBQ", benefit: "Taste gaucho tradition with a feast of local flavors and slow fire." },
    { name: "Hot Tubs", benefit: "Deep relaxation and total disconnection under the infinite Patagonian sky." },
    { name: "Meditation", benefit: "Calm your mind and reduce stress with deep relaxation techniques." },
    { name: "Horseback Riding", benefit: "Connect with the spirit of the native forest through ancestral trails." },
    { name: "Massages", benefit: "Release physical tension and restore your body after the adventure." }
  ],
  pt: [
    { name: "Ioga ao ar livre", benefit: "Desperte sua energia vital e encontre equilíbrio em um cenário natural único." },
    { name: "Churrasco patagônico", benefit: "Saboreie a tradição gaúcha com um banquete de sabores locais em fogo lento." },
    { name: "Banheiras de imersão", benefit: "Relaxamento profundo e desconexão total sob o céu infinito da Patagônia." },
    { name: "Meditação", benefit: "Acalme sua mente e diminua o estresse com técnicas de relaxamento profundo." },
    { name: "Cavalgadas", benefit: "Conecte-se com o espírito da floresta nativa percorrendo trilhas ancestrais." },
    { name: "Massagens", benefit: "Alivie tensões físicas e recupere seu corpo após a aventura." }
  ],
  fr: [
    { name: "Yoga en plein air", benefit: "Éveillez votre énergie vitale et trouvez l'équilibre dans un cadre naturel exceptionnel." },
    { name: "Barbecue patagonien", benefit: "Savourez la tradition gaucho avec un festin de saveurs locales à feu doux." },
    { name: "Bains nordiques", benefit: "Relaxation profonde et déconnexion totale sous le ciel infini de Patagonie." },
    { name: "Méditation", benefit: "Apaisez votre esprit et évacuez le stress grâce à des techniques de relaxation." },
    { name: "Randonnée à cheval", benefit: "Connectez-vous à la forêt indigène en parcourant des sentiers ancestraux." },
    { name: "Massages", benefit: "Libérez les tensions musculaires et régénérez votre corps après l'aventure." }
  ],
  it: [
    { name: "Yoga all'aperto", benefit: "Risveglia la tua energia vitale e trova l'equilibrio in una cornice naturale unica." },
    { name: "Barbecue patagonico", benefit: "Gusta la tradizione gaucha con un banchetto di sapori locali a fuoco lento." },
    { name: "Vasche idromassaggio", benefit: "Rilassamento profondo e disconnessione totale sotto l'infinito cielo patagonico." },
    { name: "Meditazione", benefit: "Calma la mente e riduci lo stress con tecniche di rilassamento profondo." },
    { name: "Passeggiate a cavallo", benefit: "Entra in contatto con lo spirito dei boschi nativi lungo sentieri ancestrali." },
    { name: "Massaggi", benefit: "Sciogli le tensioni muscolari e rigenera il corpo dopo l'avventura." }
  ],
  de: [
    { name: "Outdoor-Yoga", benefit: "Erwecke deine Lebensenergie und finde Balance in einzigartiger Natur." },
    { name: "Patagonisches BBQ", benefit: "Koste die Gaucho-Tradition bei einem Fest lokaler Aromen am offenen Feuer." },
    { name: "Hot Tubs", benefit: "Tiefenentspannung und Abschalten unter dem endlosen Himmel Patagoniens." },
    { name: "Meditation", benefit: "Beruhige deinen Geist und baue Stress mit Entspannungstechniken ab." },
    { name: "Reitausflüge", benefit: "Verbinde dich mit den Urwäldern auf uralten Pfaden." },
    { name: "Massagen", benefit: "Löse Verspannungen und regeneriere deinen Körper nach dem Abenteuer." }
  ]
};

